import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../../utils';

const Form = (props) => {
    const [state, setState] = useState({
        companyName: {
            name: 'companyName',
            value: props.data ? props.data.COMPANY_NAME : '',
            isRequired: true,
            error: '',
        },
        titlePrefix: {
            name: 'titlePrefix',
            value: props.data ? props.data.TITLE_PREFIX : '',
            isRequired: false,
            error: '',
        },
        companyLogo: {
            name: 'companyLogo',
            value: null, // file input
            fileName: props.data?.COMPANY_LOGO || '',
            isRequired: false,
            error: '',
        },
        defaultProfilePic: {
            name: 'defaultProfilePic',
            value: null,
            fileName: props.data?.DEFAULT_PROFILE_PIC || '',
            isRequired: false,
            error: '',
        },
        favicon: {
            name: 'favicon',
            value: null,
            fileName: props.data?.FAVICON || '',
            isRequired: false,
            error: '',
        },
    });


    useEffect(() => {
        if (props.data) {
            setState(prev => ({
                ...prev,
                companyName: {
                    ...prev.companyName,
                    value: props.data.COMPANY_NAME || '',
                    error: '',
                },
                titlePrefix: {
                    ...prev.titlePrefix,
                    value: props.data.TITLE_PREFIX || '',
                    error: '',
                },
                companyLogo: {
                    ...prev.companyLogo,
                    value: null,
                    fileName: props.data.COMPANY_LOGO || '',
                    error: '',
                },
                defaultProfilePic: {
                    ...prev.defaultProfilePic,
                    value: null,
                    fileName: props.data.DEFAULT_PROFILE_PIC || '',
                    error: '',
                },
                favicon: {
                    ...prev.favicon,
                    value: null,
                    fileName: props.data.FAVICON || '',
                    error: '',
                },
            }));
        }
    }, [props.data]);
    const onChange = (e) => {
        const { name, value, files } = e.target;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: files ? files[0] : value,
                error: prev[name].isRequired && !(files ? files[0] : value)
                    ? 'This field is required'
                    : '',
            },
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const formData = new FormData();

            formData.append('companyName', state.companyName.value);
            formData.append('titlePrefix', state.titlePrefix.value);
            
            if (state.companyLogo.value) {
                formData.append('companyLogo', state.companyLogo.value);
            }
            if (state.favicon.value) {
                formData.append('favicon', state.favicon.value);
            }
            if (state.defaultProfilePic.value) {
                formData.append('defaultProfilePic', state.defaultProfilePic.value);
            }

            props.onSubmit(formData); // Send FormData
        }
    };

    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <form onSubmit={onSubmit} encType="multipart/form-data">
                <div className="row">
                    {Object.keys(state).map((key) => {
                        const field = state[key];
                        const isFileField = key === 'companyLogo' || key === 'defaultProfilePic' || key === 'favicon';
                        return (
                            <div className="col-lg-6" key={key}>
                                <div className="mb-3">
                                    <label htmlFor={key}>
                                        {field.name.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                        {field.isRequired && <span className="text-danger"> *</span>}
                                    </label>
                                    <input
                                        type={isFileField ? 'file' : 'text'}
                                        className={`form-control ${field.error ? 'is-invalid' : ''}`}
                                        id={key}
                                        name={field.name}
                                        placeholder={isFileField ? '' : `Enter ${field.name}`}
                                        onChange={onChange}
                                        value={!isFileField ? field.value : undefined}
                                    />
                                    {isFileField && field.fileName && (
                                        <a href={`${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${field.fileName}`} className="mt-1 text-muted small">Selected: {field.fileName}</a>
                                    )}
                                    {field.error && (
                                        <div className="invalid-feedback">{field.error}</div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <button
                                type="submit"
                                className="btn btn-success waves-effect btn-label waves-light me-2"
                            >
                                <i className="bx bx-check-double label-icon" /> {props.buttonName}
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger waves-effect btn-label waves-light"
                                onClick={() => window.history.back()}
                            >
                                <i className="bx bx-block label-icon" /> Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );
};

export default Form;
